// extracted by mini-css-extract-plugin
module.exports = {"bodyContent":"BodyContent_bodyContent__o9KWW","inputWrapper":"BodyContent_inputWrapper__97Bjc"};